import React, { useState } from 'react';
import { useAppSelector } from '../../store/store';
import { getSessions } from '../../store/selector/session.selector';
import SidebarSession from './SidebarSession';
import { getSessionsLoading } from '../../store/selector/common.selector';

interface IProps {
    store: any;
}

const SidebarSessions = ({ store }: IProps) => {
    const sessions = useAppSelector(getSessions);
    const fetchSessionLoading = useAppSelector(getSessionsLoading);

    const [isSessionOpen, setIsSessionOpen] = useState(true);

    const toggleSession = () => {
        setIsSessionOpen(!isSessionOpen);
    };

    return (
        <div className="tw-w-full">
            <div
                className="tw-full tw-flex tw-items-center tw-justify-start tw-gap-x-[10px] tw-p-2 tw-rounded-md tw-cursor-pointer"
                onClick={toggleSession}
            >
                <i className="ph-bold ph-chat-teardrop lg"></i>
                <div className="tw-w-full tw-flex tw-items-center tw-justify-between">
                    <span className=" tw-text-base tw-font-medium">Campaign History</span>
                    {isSessionOpen ? (
                        <i className="ph ph-caret-up md"></i>
                    ) : (
                        <i className="ph ph-caret-down md"></i>
                    )}
                </div>
            </div>
            {isSessionOpen && (
                <>
                    {fetchSessionLoading ? (
                        <>Fetching...</>
                    ) : (
                        <div className="tw-w-full tw-overflow-y-scroll tw-max-h-[250px]">
                            {sessions.map((session) => (
                                <SidebarSession
                                    key={session.sessionKey}
                                    session={session}
                                    store={store}
                                />
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SidebarSessions;
